import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup
} from '@angular/forms';

@Component({
  selector: 'color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss']
})
export class ColorPickerComponent implements OnInit {
  formGroup: UntypedFormGroup;
  colors: UntypedFormArray;

  @Input()
  public title: string;
  @Input()
  public subtitle: string;
  @Output()
  public answer = new EventEmitter();

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit() {
    this.formGroup = this.initColorPicker();
    this.colors = this.formGroup.get('colors') as UntypedFormArray;
  }

  private initColorPicker() {
    return this.formBuilder.group({
      colors: this.formBuilder.array([this.createItem()])
    });
  }

  addColor() {
    this.colors.push(this.createItem());
  }

  createItem(): UntypedFormGroup {
    return this.formBuilder.group({
      name: ''
    });
  }

  answered($event) {
    this.answer.emit(this.colors);
  }
}
